import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 900,
      "& $header": {
        padding: 0,
      },
    },
    // formTabs: {
    //   marginBottom: theme.spacing(2),
    //   marginTop: theme.spacing(2),
    // },
    // formContent: {
    //   padding: theme.spacing(3),
    // },
    content: {
      padding: theme.spacing(4),
    },
    header: {},
  })
);
